import * as React from 'react';

import { VariantProps, cn, tv } from './utils/cn';

const badgeVariants = tv({
  base: 'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:ring-2 focus:ring-border-accent-quaternary focus:ring-offset-2 focus:outline-hidden',
  variants: {
    variant: {
      default:
        'border-transparent bg-bg-accent-strong-primary text-text-accent-strong hover:bg-bg-accent-strong-primary/80',
      secondary:
        'border-transparent bg-bg-tertiary text-text-primary hover:bg-bg-tertiary/80',
      destructive:
        'border-transparent bg-bg-negative-strong-primary text-text-negative-strong hover:bg-bg-negative-strong-primary/80',
      success:
        'border-transparent bg-bg-lightgreen-strong text-text-lightgreen-strong hover:bg-bg-lightgreen-strong/80',
      info: 'border-transparent bg-text-tertiary text-bg-secondary hover:bg-text-tertiary/80',
      infoSubtle: 'border-transparent bg-bg-info-subtle text-text-info-subtle',
      warningSubtle:
        'border-transparent bg-bg-warning-subtle text-text-warning-strong',
      outline: 'text-text-secondary',
    },
    uppercase: {
      true: 'uppercase',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, uppercase, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, uppercase }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
